import { useState } from "react"
import { Link } from "react-router-dom"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"

const SCRIPT_URL = "https://script.google.com/macros/s/AKfycbwenfFpcga7at8nn1ox0RcTHsvpqz35ZDPUHgRziME_127QyyIFVy8ORGm0X5KdGSy3/exec"

export default function RefundRequest() {
    const [phase, setPhase]           = useState("code") // "code" | "otp" | "success"
    const [code, setCode]             = useState("")
    const [otp, setOtp]               = useState("")
    const [loading, setLoading]       = useState(false)
    const [error, setError]           = useState("")
    const [maskedEmail, setMaskedEmail] = useState("")

    async function submitCode(e) {
        e.preventDefault()
        setError("")
        const trimmed = code.trim().toUpperCase()
        if (!trimmed) { setError("Please enter your access code."); return }
        setLoading(true)
        try {
            const url = SCRIPT_URL + "?action=refund_request&code=" + encodeURIComponent(trimmed)
            const res  = await fetch(url)
            const json = await res.json()
            if (json.ok) {
                setMaskedEmail(json.email || "")
                setPhase("otp")
            } else {
                setError(json.error || "Code not found. Please check and try again.")
            }
        } catch (err) {
            setError("Something went wrong. Please try again.")
        }
        setLoading(false)
    }

    async function submitOtp(e) {
        e.preventDefault()
        setError("")
        if (!otp.trim()) { setError("Please enter the verification code from your email."); return }
        setLoading(true)
        try {
            const url = SCRIPT_URL
                + "?action=refund_verify"
                + "&code=" + encodeURIComponent(code.trim().toUpperCase())
                + "&otp="  + encodeURIComponent(otp.trim())
            const res  = await fetch(url)
            const json = await res.json()
            if (json.ok) {
                setPhase("success")
            } else {
                setError(json.error || "Invalid or expired code. Please try again.")
            }
        } catch (err) {
            setError("Something went wrong. Please try again.")
        }
        setLoading(false)
    }

    const inputStyle = {
        width: "100%", boxSizing: "border-box",
        border: "1.5px solid #D1D5DB", borderRadius: 10,
        padding: "12px 14px", fontSize: 16,
        fontFamily: "Inter, sans-serif", color: "#111827",
        outline: "none",
    }

    const btnStyle = {
        width: "100%", padding: "14px", borderRadius: 12,
        background: "#2563EB", color: "white", border: "none",
        fontFamily: "Inter, sans-serif", fontWeight: 700, fontSize: 16,
        cursor: loading ? "not-allowed" : "pointer",
        opacity: loading ? 0.7 : 1,
    }

    return (
        <div style={{ width: "100%", background: "white", fontFamily: "Inter, sans-serif", color: "#111827" }}>
            <Navbar />
            <div style={{ maxWidth: 520, margin: "0 auto", padding: "72px 24px 120px" }}>

                {phase === "code" && (
                    <form onSubmit={submitCode}>
                        <h1 style={{ fontSize: 36, fontWeight: 800, letterSpacing: "-0.04em", margin: "0 0 10px" }}>
                            Request a Refund
                        </h1>
                        <p style={{ fontSize: 16, color: "#6B7280", lineHeight: 1.7, margin: "0 0 28px" }}>
                            We offer a <strong style={{ color: "#111827" }}>7-day money-back guarantee</strong>.
                            Enter your access code below — we'll send a verification code to the email you used at checkout.
                        </p>

                        <div style={{ marginBottom: 16 }}>
                            <label style={{ display: "block", fontSize: 14, fontWeight: 600, marginBottom: 6 }}>
                                Access Code
                            </label>
                            <input
                                type="text"
                                value={code}
                                onChange={e => setCode(e.target.value)}
                                placeholder="QWIZ-XXXX-XXXX"
                                style={{ ...inputStyle, textTransform: "uppercase", letterSpacing: "0.05em" }}
                                autoFocus
                            />
                        </div>

                        {error && (
                            <div style={{ background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 8, padding: "10px 14px", fontSize: 14, color: "#DC2626", marginBottom: 16 }}>
                                {error}
                            </div>
                        )}

                        <button type="submit" style={btnStyle} disabled={loading}>
                            {loading ? "Sending…" : "Send Verification Code →"}
                        </button>

                        <p style={{ fontSize: 13, color: "#9CA3AF", textAlign: "center", marginTop: 20, lineHeight: 1.6 }}>
                            Need help? Email <a href="mailto:listener@qwiztime.ai" style={{ color: "#2563EB" }}>listener@qwiztime.ai</a>
                        </p>
                    </form>
                )}

                {phase === "otp" && (
                    <form onSubmit={submitOtp}>
                        <h1 style={{ fontSize: 36, fontWeight: 800, letterSpacing: "-0.04em", margin: "0 0 10px" }}>
                            Check Your Email
                        </h1>
                        <p style={{ fontSize: 16, color: "#6B7280", lineHeight: 1.7, margin: "0 0 28px" }}>
                            We sent a 6-digit verification code to{" "}
                            <strong style={{ color: "#111827" }}>{maskedEmail || "your email"}</strong>.
                            {" "}It expires in 15 minutes.
                        </p>

                        <div style={{ marginBottom: 16 }}>
                            <label style={{ display: "block", fontSize: 14, fontWeight: 600, marginBottom: 6 }}>
                                Verification Code
                            </label>
                            <input
                                type="text"
                                inputMode="numeric"
                                value={otp}
                                onChange={e => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                                placeholder="123456"
                                style={{ ...inputStyle, letterSpacing: "0.2em", fontSize: 22 }}
                                autoFocus
                            />
                        </div>

                        {error && (
                            <div style={{ background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: 8, padding: "10px 14px", fontSize: 14, color: "#DC2626", marginBottom: 16 }}>
                                {error}
                            </div>
                        )}

                        <button type="submit" style={btnStyle} disabled={loading}>
                            {loading ? "Verifying…" : "Confirm Refund →"}
                        </button>

                        <p style={{ fontSize: 13, color: "#9CA3AF", textAlign: "center", marginTop: 20 }}>
                            <button
                                type="button"
                                onClick={() => { setPhase("code"); setError(""); setOtp("") }}
                                style={{ background: "none", border: "none", color: "#6B7280", cursor: "pointer", fontSize: 13, textDecoration: "underline", fontFamily: "inherit" }}
                            >
                                Start over
                            </button>
                        </p>
                    </form>
                )}

                {phase === "success" && (
                    <div style={{ textAlign: "center" }}>
                        <div style={{ fontSize: 52, marginBottom: 20 }}>✓</div>
                        <h1 style={{ fontSize: 34, fontWeight: 800, letterSpacing: "-0.04em", margin: "0 0 14px" }}>
                            Refund Request Received
                        </h1>
                        <p style={{ fontSize: 16, color: "#6B7280", lineHeight: 1.8, margin: "0 0 32px" }}>
                            Your access code <strong style={{ color: "#111827" }}>{code.trim().toUpperCase()}</strong> has been disabled.
                            Our team will process your refund within <strong style={{ color: "#111827" }}>1–2 business days</strong> and
                            send a confirmation to your email.
                        </p>
                        <Link
                            to="/"
                            style={{
                                display: "inline-block",
                                background: "#F3F4F6", color: "#374151",
                                padding: "12px 28px", borderRadius: 12,
                                textDecoration: "none", fontWeight: 700, fontSize: 15,
                            }}
                        >
                            Back to Home
                        </Link>
                    </div>
                )}
            </div>
            <Footer />
        </div>
    )
}
